import React, { useState } from 'react'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { toast } from 'react-toastify';

import Button from '../SelectValue/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import swal from 'sweetalert';
import postService from '../../Services/post-service';
import NonnegativeInputField from '../SelectValue/NonnegativeInputfield';
import Loading from '../SelectValue/Loading';
import Inputtt from '../SelectValue/Inputtt';
import { getApiErrorMessage } from '../../utils/apiError';
import ImageUploader from '../Dropdown';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  maxHeight: '90vh',
  overflow: 'auto',
  bgcolor: 'white',
  boxShadow: 24,
};

function CreateSavingsCategory({ open, handleClose }) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [planType, setPlanType] = useState('ADMIN_GOAL')
  const [savingsType, setSavingsType] = useState('FLEX_TIME')
  const [fixedAmount, setFixedAmount] = useState('')
  const [minDurationMonths, setMinDurationMonths] = useState('')
  const [profitRate, setProfitRate] = useState('')
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(false)

  const validateForm = () => {
    if (images.length === 0) {
      toast.warning('Please select a savings category image')
      return false
    }

    if (planType === 'ADMIN_GOAL' && !fixedAmount) {
      toast.warning('Fixed amount is required when plan type is Admin Goal')
      return false
    }

    const isMinDurationRequired = 
      planType === 'ADMIN_GOAL' || 
      savingsType === 'FLEX_TIME' || 
      savingsType === 'STASH'

    if (isMinDurationRequired && !minDurationMonths) {
      toast.warning('Minimum duration is required for this plan/savings type combination')
      return false
    }

    return true
  }

  const onSubmit = (e) => {
    e.preventDefault()
    
    if (!validateForm()) {
      return
    }

    setLoading(true)

    const formData = new FormData()
    formData.append('name', name)
    formData.append('description', description)
    formData.append('planType', planType)
    formData.append('savingsType', savingsType)
    formData.append('fixedAmount', fixedAmount)
    formData.append('minDurationMonths', minDurationMonths)
    formData.append('profitRate', profitRate)
    formData.append('image', images[0])

    postService.createSavingsCategory(formData).then(
      (response) => {
        setLoading(false)
        if (response.data.status === '2000') {
          swal("Savings category created successfully").then(() => {
            handleClose()
            window.location.reload()
          })
        } else {
          swal(response.data.description)
        }
      },
      (error) => {
        setLoading(false)
        swal(getApiErrorMessage(error, 'Error creating savings category'))
      }
    )
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style} className='rounded-lg p-6 pt-10'>
          <Loading open={loading} />
          <div>
            <div className='flex mb-6 justify-end'>
              <CancelIcon
                onClick={handleClose}
                className='text-back-color2 cursor-pointer text-[38px]'
                fontSize="large"
              />
            </div>

            <form onSubmit={onSubmit}>
              <div className='mb-4'>
                <Inputtt
                        label='Category name'
                        value={name}
                        onChange={setName}
                    />
              </div>

              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Description</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                  placeholder=""
                  className='p-4 w-full outline-0 rounded-lg border bg-white'
                  rows="3"
                />
              </div>

              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Plan Type</label>
                <select
                  value={planType}
                  onChange={(e) => setPlanType(e.target.value)}
                  className='p-4 w-full outline-0 rounded-lg border bg-white'
                >
                  <option value="ADMIN_GOAL">Admin Goal</option>
                  <option value="TEMPLATE">Template</option>
                </select>
              </div>

              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Savings Type</label>
                <select
                  value={savingsType}
                  onChange={(e) => setSavingsType(e.target.value)}
                  className='p-4 w-full outline-0 rounded-lg border bg-white'
                >
                  <option value="FLEX_TIME">Flex Time</option>
                  <option value="FLEX_AMOUNT">Flex Amount</option>
                  <option value="STASH">Stash</option>
                </select>
              </div>

              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Fixed Amount</label>
                <NonnegativeInputField
                  label=""
                  valuee={fixedAmount}
                  onChange={setFixedAmount}
                />
              </div>
              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Profit Rate (%)</label>
                <NonnegativeInputField
                  label=""
                  valuee={profitRate}
                  onChange={setProfitRate}
                />
              </div>

              <div className='mb-6'>
                <label className='mb-2 block font-medium'>Minimum Duration (Months)</label>
                <select
                  value={minDurationMonths}
                  onChange={(e) => setMinDurationMonths(e.target.value)}
                  className='p-4 w-full outline-0 rounded-lg border bg-white'
                >
                  <option value="">Select Duration</option>
                  <option value="1">1 month</option>
                  <option value="3">3 months</option>
                  <option value="6">6 months</option>
                  <option value="9">9 months</option>
                  <option value="12">12 months</option>
                </select>
              </div>

              <div className='mb-4'>
                <label className='mb-2 block font-medium'>Category Image</label>
                <ImageUploader
                  images={images}
                  setImages={setImages}
                  multiple={false}
                  minimumText='Selected image'
                />
              </div>

              <div className='flex justify-end'>
                <Button name="Create Category" />
              </div>
            </form>
          </div>
        </Box>
      </Fade>
    </Modal>
  )
}

export default CreateSavingsCategory
